import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useImageSize = (id: string): [number, number] => {
  const imageDb = useSelector((state: RootState) => state.imageDb);
  if (!Object.keys(imageDb.images).includes(id)) return [0, 0];

  const dataUrl = imageDb.images[id].dataUrl;
  const img = new Image();
  img.src = dataUrl;
  img.style.display = 'none';
  const width = img.width;
  const height = img.height;
  img.remove();

  return [width, height];
}

export default useImageSize;
